import { dom as o } from './dom.js';
import { env as t } from './env.js';

function m(r) {
  if (t.isServer) return null;
  if (r instanceof Node) return r.ownerDocument;

  if (r != null && r.hasOwnProperty("value")) {
    var n = o(r);
    if (n) return n.ownerDocument;
  }

  return document;
}

export { m as getOwnerDocument };